import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  VStack,
  HStack,
  RadioGroup,
  Radio,
  IconButton,
} from "@chakra-ui/react";
import { FaGlobe } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "en", label: "English" },
  { code: "mm", label: "မြန်မာ (ယူနီကုဒ်)" },
];

export const ChangeLanguageModal = ({ isOpen, onClose }) => {
  const { t, i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);

  useEffect(() => {
    // Update document direction when language changes
    document.documentElement.dir = i18n.language === "mm" && "ltr";
  }, [i18n.language]);

  useEffect(() => {
    // Reset selection when modal opens
    if (isOpen) {
      setSelectedLanguage(i18n.language);
    }
  }, [isOpen, i18n.language]);

  const handleSave = () => {
    localStorage.setItem("i18nextLng", selectedLanguage); // Save language
    i18n.changeLanguage(selectedLanguage);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered motionPreset="slideInBottom">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("select_language")}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <RadioGroup onChange={setSelectedLanguage} value={selectedLanguage}>
            <VStack spacing={3} align="start">
              {languages.map((lang) => (
                <HStack key={lang.code} w="full" p={2}>
                  <Radio size="sm" value={lang.code}>{lang.label}</Radio>
                </HStack>
              ))}
            </VStack>
          </RadioGroup>
        </ModalBody>
        <ModalFooter justifyContent="center">
          <Button width={'25%'} size={'sm'} colorScheme="blue" onClick={handleSave}>
            OK
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export const LanguageSwitcher = ({ onOpen }) => {
  //const { i18n } = useTranslation();

  return (
    <IconButton
      icon={<FaGlobe />}
      aria-label="Change Language"
      onClick={onOpen}
      colorScheme="blue"
      variant="outline"
    />
  );
};

export default ChangeLanguageModal;